<template>
  <BjDrawerForm ref="BjDrawerForm" :form="form" :rules="rules" label-width="135px" width="61.8%" @handleConfirm="handleConfirm">
    <div class="flex-spacebetween">
      <el-col :span="11">
        <el-form-item :label="$t('goodsClassify.common.ClassificationName')" prop="name">
          <BjInput v-model="form.name" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('chooseText')" clearable />
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <BjFormItemCode v-model="form.code" :readonly="isEdit" :label="$t('goodsClassify.common.ClassificationCode')" :placeholder="$t('goodsClassify.dialog.lettersNumbers')" prop="code" :validator="validatorGoodsClassifyCode" />
      </el-col>
    </div>
    <div class="flex-spacebetween">
      <el-col :span="11">
        <!-- 叶子结点不展示 -->
        <el-form-item :label="$t('goodsClassify.dialog.ParentClassification')" prop="parentId">
          <BjGoodsTypeTreeSelect v-if="isBjGoodsTypeTreeSelectVisible" v-model="form.parentId" :query="{ statusFlag: true, subFlag: false }" has-root :disabled="isEdit" />
        </el-form-item>
      </el-col>
      <!-- <el-col :span="11">
        <el-form-item :label="$t('table.statusText')" prop="statusFlag">
          <el-switch v-model="form.statusFlag" />
        </el-form-item>
      </el-col> -->
      <el-col :span="11">
        <el-form-item prop="subFlag">
          <template #label>
            {{ $t('goodsClassify.dialog.LeafNode') }}
            <el-tooltip effect="dark" placement="top-start" :content="$t('goodsClassify.dialog.WhenLeafNode')">
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <el-switch v-model="form.subFlag" />
        </el-form-item>
      </el-col>
    </div>
    <el-col :span="20">
      <el-form-item :label="$t('goodsClassify.dialog.Remarks')" prop="remark">
        <BjInput v-model="form.remark" :maxlength="MAX_LENGTH.DEFAULT" :placeholder="$t('inputText')" clearable />
      </el-form-item>
    </el-col>
    <GoodsAttributeList ref="GoodsAttribute" :parent-id="form.parentId" />
  </BjDrawerForm>
</template>
<script>
import { goodsApi } from '@/api';
import GoodsAttributeList from '@/views/center-business/goods/components/GoodsAttributeList';
import { validatorGoodsClassifyName, patternGoodsClassifyCode } from '@/utils/validate';
const getDefaultForm = () => {
  return {
    name: null,
    code: null,
    id: null,
    parentId: null,
    statusFlag: 1,
    subFlag: false,
    remark: null,
  };
};

export default {
  components: {
    GoodsAttributeList,
  },
  data() {
    return {
      // 表单参数
      isEdit: false,
      form: getDefaultForm(),
      // 表单校验
      rules: {
        name: [{ required: true, validator: this.patternGoodsClassifyName, trigger: 'blur' }],
        parentId: [{ required: true, message: this.$t('goodsClassify.dialog.category'), trigger: ['blur', 'change'] }],
      },
      isBjGoodsTypeTreeSelectVisible: false,
    };
  },
  watch: {},
  mounted() {},
  methods: {
    patternGoodsClassifyName(rule, value, callback) {
      if (!value) {
        return callback(new Error(this.$t('PleaseClassificationText')));
      }
      if (!validatorGoodsClassifyName.test(value)) {
        callback(new Error(this.$t('PleaseCENText')));
      } else {
        callback();
      }
    },
    validatorGoodsClassifyCode(rule, value, callback) {
      if (typeof value == 'number') value = String(value);
      if (!value) {
        if (rule.required) {
          callback(new Error(this.$t('inputText')));
        } else {
          callback();
        }
      } else {
        if (!patternGoodsClassifyCode.test(String(value))) {
          callback(new Error(this.$t('Please20NumbersText')));
        } else {
          callback();
        }
      }
    },
    show(info) {
      this.isBjGoodsTypeTreeSelectVisible = true;
      this.isEdit = !!info;
      this.$refs.BjDrawerForm.show();
      this.$refs.BjDrawerForm.setTitle(this.isEdit ? this.$t('goodsClassify.dialog.EditClassification') : this.$t('goodsClassify.dialog.CreateCategory'));
      this.form = Object.assign(getDefaultForm(), info || {});
      if (this.isEdit) {
        this.$nextTick(() => {
          this.$refs.GoodsAttribute.setAttributeList(info.attributeList);
        });
        if (info.level === 1) {
          this.form.parentId = 'root';
        }
      }
    },
    handleConfirm() {
      const API_DATA = this.$lodash.clone(this.form);
      API_DATA['attributeList'] = this.$refs.GoodsAttribute.attributeList;
      if (API_DATA.parentId === 'root') API_DATA.parentId = null;
      if (this.isEdit) {
        API_DATA['_innerMap'] = {};
      }
      if (this.isEdit) {
        this.updateApi(API_DATA);
      } else {
        this.addApi(API_DATA);
      }
    },
    reFresh() {
      this.$emit('reFresh');
    },
    addApi(API_DATA) {
      goodsApi.addCategory(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    updateApi(API_DATA) {
      goodsApi.updateCategory(API_DATA).then(res => {
        if (res.id || res._token || res.content || Array.isArray(res) || res.failed === false) {
          this.$message.success(this.$t('toast.operationSuccessText'));
          setTimeout(() => {
            this.$refs.BjDrawerForm.hide();
            this.reFresh();
          }, 500);
        }
      });
    },
    onDelSelectedStore() {
      this.selectedRowStore.forEach(row => {
        this.attributeList.splice(
          this.attributeList.findIndex(e => e.BJ_EBC_ID == row.BJ_EBC_ID),
          1,
        );
      });
      // 清除选中状态
      this.$refs.storeTable.clearSelection();
    },
  },
};
</script>
